import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import { makeSelectStoreIsInDefultAreaMode } from '../../../containers/App/selectors'
import { orgUrl } from '../../../utils/mtiUtils'

class AddAreasToStore extends React.PureComponent {
  render() {
    const {
      params: { sId, sName, fId, fName, aId, aName, fxId },
      isDefaultAreaMode,
    } = this.props
    const isShown = isDefaultAreaMode && sId && fId && aId && !fxId
    return isShown ? (
      <div key="breadcrumb-control" className="breadcrumb-control  ml-5">
        <Link
          to={`${orgUrl()}/stores/${sId}/${sName}/floors/${fId}/${fName}?areaId=${aId}&areaName=${aName}&isStatic=false`}
        >
          ADD AREAS TO STORE
        </Link>
      </div>
    ) : null
  }
}

AddAreasToStore.propTypes = {
  params: PropTypes.object,
  isDefaultAreaMode: PropTypes.bool,
}

const mapStateToProps = createStructuredSelector({
  isDefaultAreaMode: (state, ownProps) =>
    makeSelectStoreIsInDefultAreaMode(ownProps.params.sId)(state, ownProps),
})

export default connect(mapStateToProps)(AddAreasToStore)
